import React from 'react';
import './Pickevent.css'
import pic20 from '../../assets/pic20.png'
import pic7 from '../../assets/pic7.png'
import pic9 from '../../assets/pic9.png'
import pic11 from '../../assets/pic11.png'
import pic21 from '../../assets/pic21.png'
import { useState } from 'react';
import { useTranslation } from 'react-i18next';




const Pickevent = () => {

const { t, i18n } = useTranslation();
const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';


      const [searchActive, setSearchActive] = useState(false);
  const [cardSelected, setCardSelected] = useState(false);
    return ( 
        <form className='form1-sec6'  dir={direction}>
            <h2 className='title-card-sec6'>{t('Select Event')}</h2>
            <fieldset className='container-events-search-and-output'>
                    <fieldset className={`serach-input-cont ${searchActive ? 'active-card2' : ''}`}
          onClick={() => setSearchActive(true)}>
                        <img src={pic20} alt='search'></img>
                        
                        <input className='serach-text' placeholder={t('Search events...')}></input>
                    </fieldset>

                    <article className={`recommendation-crads ${cardSelected ? 'active-card' : ''}`}
          onClick={() => setCardSelected(!cardSelected)}
                    >
                            <figure className='container-img-recomm'>
                                <img className='imgs-card-rec' src={pic7} alt='pic'></img>
                            </figure>
                            
                                <article className='text-part-recomm'>
                                    <h2 className='header-crad-recom'>{t('Shakira Live in Egypt')}</h2>
                                   
                                    <article className='cont-deta-rec'>
                                        <article className='details-cont-card-recomm'>
                                            <img src={pic9} alt='pic'></img>
                                            <h3 className='date-rec'>{t('April 7, 2026')}</h3>
                                        </article>

                                        <article className='last-cont-card-recomm'>
                                    <article className='details-cont-card-recomm'>
                                            <img src={pic11} alt='pic'></img>
                                            <h3 className='date-rec'>{t('Pyramids of Giza')}</h3>
                                        </article>
                                         <h2 className='price-card-recomm'>{t('1200 – 5000 EGP')}</h2>
                                </article>

                               
                                </article>
                         

                            </article>
                    </article>

            </fieldset>


            <img className='circle-card-recomm' src={pic21} alt='pic'></img>


        </form>
     );
}
 
export default Pickevent;